import { useMemo } from 'react';

function useReducedLabelIndexes({
  dataLength,
  skipEveryNthLabel = -1
}) {
  const visibleIndexesForWideCharts = useMemo(() => {
    if (dataLength === 0 || skipEveryNthLabel === 1) {
      return [];
    }

    return Array(dataLength).fill(null).map((_, index) => index).filter((_, index) => index % skipEveryNthLabel === 0);
  }, [dataLength, skipEveryNthLabel]);
  return visibleIndexesForWideCharts;
}

export { useReducedLabelIndexes };
